module.exports = __webpack_public_path__ + "img/Boy_030028.16c2a54b.png";